export default function ({ app }) {
	app.store.commit("pyramid/updatePyramidSolved", false, { root: true });

	// We have to reset the tried out words when changing levels
	// Otherwise new levels will mark tiles as 'wrong' based on other level's tried out words.
	app.store.commit("input/updateTriedOutWords", [], { root: true });
}
